import React, { useContext, useMemo } from 'react'
import { GlobalContext } from '../context/globalContext'

const IncomeExpences = () => {
  const { state } = useContext(GlobalContext)
  const { transactions } = state

  const { income, expense } = useMemo(() => {
    const amounts = transactions.map((t) => t.amount)
    const incomeSum = amounts
      .filter((a) => a > 0)
      .reduce((acc, val) => acc + val, 0)
    const expenseSum = amounts
      .filter((a) => a < 0)
      .reduce((acc, val) => acc + val, 0)
    return { income: incomeSum, expense: Math.abs(expenseSum) }
  }, [transactions])
  return (
    <div>
      <div>
        <h4>Income</h4>
        <p>{income.toFixed(2)}</p>
      </div>

      <div>
        <h4>Expense</h4>
        <p>{expense.toFixed(2)}</p>
      </div>
    </div>
  )
}

export default IncomeExpences
